// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const PlusLargeIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 4a1 1 0 00-1 1v6H5a1 1 0 00-1 1 1 1 0 001 1h6v6a1 1 0 001 1 1 1 0 001-1v-6h6a1 1 0 001-1 1 1 0 00-1-1h-6V5a1 1 0 00-1-1z"/></svg>'} />;

PlusLargeIcon.displayName = 'PlusLargeIcon';

export default PlusLargeIcon;
